import Icon from "@mui/material/Icon";
import Logout from "@mui/icons-material/Logout";
import Task from "@mui/icons-material/Task";
import LogOut from "./pages/LandingPages/LogOut/LogOut";

const routes = [
  {
    name: "Home",
    icon: <Icon>home</Icon>,
    route: "/app/trainerdashboard",
  },
  {
    name: <span style={{ fontWeight: 'bold' }}>Trainings</span>,
    name: "Trainings",
    icon: <Task />,
    route: "/app/traininglistindex",
  },
  {
    name: "LogOut",
    route: "/app/logout",
    component: <LogOut />,
    icon: <Logout />,
  },
];

export default routes;
